import React from 'react';
import './index.css';
import './styles/beacon-tokens.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import CssBaseline from '@mui/material/CssBaseline';

import App from './App';
import store from './store/store';
import { TenantProvider } from './contexts/TenantContext';
import { CartProvider } from './contexts/CartContext';
import ErrorBoundary from './components/ErrorBoundary';

console.debug('[TC:boot] index.js — DOM loaded, mounting React');
const container = document.getElementById('root');
if (!container) {
  console.error('[TC:boot] FATAL: #root element not found in DOM');
}
const root = createRoot(container);
console.debug('[TC:boot] createRoot OK, calling render');

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <TenantProvider>
          <CartProvider>
            <CssBaseline />
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </CartProvider>
        </TenantProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
